export const Mydata = {
  data() {
    return {
      systemIds: [
        { id: '1', title: 'Android' },
        { id: '2', title: 'ios' },
        { id: '3', title: '小程序' },
      ],
      tableOpt: {
        currentPage: 1,
        pageSize: 10,
      },
      dimensionalData: [
        {
          title: '日期',
          value: 1000
        },
        {
          title: '项目',
          value: 1003,
        },
        {
          title: '事业群',
          value: 1001
        },
        {
          title: '部门',
          value: 1002
        },
        {
          title: '应用',
          value: 1004
        },
        {
          title: '系统',
          value: 1005
        },
      ],
      // 表格
      column: [
        /* {
          fixed: false,
          label: "日期",
          prop: "date",
        },
        {
          label: "星期",
          prop: 'week',
        }, */
        {
          label: "整体情况",
          width: 120,
          children: [
            {
              label: "会员收入",
              prop: "order_price_pay",
              sortable: 'custom',
            },
            {
              label: "会员arpu",
              prop: "vip_arpu",
              sortable: 'custom',

            },
            {
              label: "总订单量",
              prop: "order_num_pay",
              sortable: 'custom',
            },
            {
              label: "总客单价",
              prop: "order_unit_price",
              sortable: 'custom',

            },
          ],
        },
        {
          label: "首购情况",
          children: [
            {
              label: "首购会员收入",
              prop: "order_first_purchase",
              sortable: 'custom',
              width: "130"
            },
            {
              label: "首购会员arpu",
              prop: "order_first_purchase_arpu",
              sortable: 'custom',
              width: "138"
            },
            {
              label: "首购金额占比",
              prop: "order_first_purchase_rate",
              sortable: 'custom',
              width: "130"
            },
            {
              label: "首购订单量",
              prop: "order_first_purchase_num",
              sortable: 'custom',
            },
            {
              label: "首购订单占比",
              prop: "order_first_purchase_num_rate",
              sortable: 'custom',
              width: "130"
            },
            {
              label: "首购客单价",
              prop: "order_first_purchase_unit_price",
              sortable: 'custom',

            },
          ],
        },
        {
          label: "复购情况",
          children: [{
            label: "复购会员收入",
            prop: "order_repurchase",
            sortable: 'custom',
            width: "130"
          },
          {
            label: "复购会员arpu",
            prop: "order_repurchase_arpu",
            sortable: 'custom',
            width: "138"
          },
          {
            label: "复购金额占比",
            prop: "order_repurchase_rate",
            sortable: 'custom',
            width: "130"
          },
          {
            label: "复购订单量",
            prop: "order_repurchase_num",
            sortable: 'custom',
          },
          {
            label: "复购订单占比",
            prop: "order_repurchase_num_rate",
            sortable: 'custom',
            width: "130"
          },
          {
            label: "复购客单价",
            prop: "order_repurchase_unit_price",
            sortable: 'custom',

          },
          ],
        },
        {
          label: "转化率",
          children: [{
            label: "新用户激活付费率",
            prop: "order_new_pay_rate",
            sortable: 'custom',
            width: "160"
          },
          {
            label: "新用户激活注册率",
            prop: "order_new_reg_rate",
            sortable: 'custom',
            width: "160"
          },
          {
            label: "新用户注册下单率",
            prop: "order_reg_pay_rate",
            sortable: 'custom',
            width: "160"
          },
          {
            label: "新用户支付成功率",
            prop: "order_new_user_pay_rate",
            sortable: 'custom',
            width: "160"
          },
          {
            label: "老用户支付成功率",
            prop: "order_old_user_pay_rate",
            sortable: 'custom',
            width: "160"
          },
          ],
        },
        {
          label: "支付方式",
          children: [{
            label: "支付宝支付占比",
            prop: "order_pay_zfb_rate",
            sortable: 'custom',
            width: 160
          },
          {
            label: "微信支付占比",
            prop: "order_pay_wx_rate",
            sortable: 'custom',

            width: 160
          },
          {
            label: "APPStore支付占比",
            prop: "order_pay_apple_rate",
            sortable: 'custom',

            width: 180
          },
          ],
        },
        {
          label: "续订情况",
          children: [{
            label: "支付宝签约订单占比",
            prop: "order_sign_rate",
            width: 160,
            sortable: 'custom',

          },
          ],
        },
      ],
      percent: ['order_first_purchase_rate', "order_first_purchase_num_rate", "order_repurchase_rate", "order_repurchase_num_rate", "order_new_pay_rate", "order_new_reg_rate", "order_reg_pay_rate", "order_new_user_pay_rate", "order_old_user_pay_rate", "order_pay_zfb_rate", "order_pay_wx_rate", "order_pay_apple_rate", "order_sign_rate"],
    }
  }
}